<template>
	<div class="pc-poster">
		<cmui-list :col="data.col||1" :border="data.border||true" :space="data.space||0">
			<cmui-list-item v-for="(key,item) in data.items">
				<a :href="item.clickUrl||'###'" data-scp="ad_{{item.id}}.{{key}}" :index="getSCP(item)">
					<img :src="item.imageUrl" alt="" v-if="item.imageUrl">
				</a>
				<pc-poster :data="item" v-if="item.items"></pc-poster>
			</cmui-list-item>
		</cmui-list>
	</div>
</template>
<script>
	let scpIndex=0;
	export default{
		name:'pc-poster',
		props:{
			data:{type:Object,default:{}}
		},
		key:0,
		methods:{
			getSCP(item){
				return `ad_${item.id}.${scpIndex}`;
			}
		}
	}
</script>